module.exports = __webpack_public_path__ + "img/talento.9d38805f.png";